import { Pipe, PipeTransform } from '@angular/core';
import { TeaserItem } from 'app/interfaces/teaser-item.model';
import { Project } from "app/interfaces/project.model";
import { Detail } from "app/interfaces/detail.model";

@Pipe({
  name: 'teaserItem'
})
export class TeaserItemPipe implements PipeTransform {

  transform(r: Detail | Project, routingDisabled: boolean): TeaserItem {

    if (Object.getOwnPropertyNames(r).indexOf('TPNumber') >= 0) {
      r = r as Project;
      return {
        Id: r.Id,
        Title: `TP-${r.TPNumber} ${r.Title}`,
        Subtitle: 'Project',
        Image: r.MainImage,
        Description: r.Summary,
        DetailUrl: '/project/' + r.Id,
        DisableRouting: routingDisabled,
        Caption: r.Caption,
      };
    }
    else {
      r = r as Detail;
      return {
        Id: +r.Id,
        Title: r.Title,
        Subtitle: 'Detail',
        Image: r.MainImage || r.Files[0],
        Description: r.Description,
        DetailUrl: `/detail/${r.Id}`,
        DisableRouting: routingDisabled,
        Caption: r.Caption,
      };
    }
  }

}
